import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedCreateServiceUsersReq } from 'app/interfaces/requests/Exposed/exposedCreateServiceUsersReq';
import { ExposedDeleteServiceUserReq } from 'app/interfaces/requests/Exposed/exposedDeleteServiceUserReq';
import { ExposedUpdateServiceUserRolesReq } from 'app/interfaces/requests/Exposed/exposedUpdateServiceUserRolesReq';
import { ExposedUpdateServiceUsersReq } from 'app/interfaces/requests/Exposed/exposedUpdateServiceUsersReq';
import { ExposedListServiceUserDomainsRes } from 'app/interfaces/responses/Exposed/exposedListServiceUserDomainsRes';
import { ExposedListServiceUsersRes } from 'app/interfaces/responses/Exposed/exposedListServiceUsersRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { TranslationService } from '../translation/translation.service';

@Injectable({
    providedIn: 'root',
})
export class ServiceUsersService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private alertsService: AlertsService,
        private router: Router,
        private loaderService: LoaderService,
        public dialog: MatDialog,
        private translationService: TranslationService
    ) {}

    public listServiceUsers(showLoader = true): Observable<Array<ExposedListServiceUsersRes>> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage(this.translationService.translate('info_fetching_information'));
        }
        let subject = new Subject<Array<ExposedListServiceUsersRes>>();
        this.http
            .get(environment.localApi + 'ServiceUser/listServiceUsers', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ExposedListServiceUsersRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    subject.next(null);
                    console.log(error);
                }
            )
            .add(() => {
                if (showLoader) {
                    this.loaderService.changeActiveLoaders(-1);
                }
            });
        return subject.asObservable();
    }

    public createServiceUser(req: ExposedCreateServiceUsersReq): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(this.translationService.translate('info_save_service_user_data'));

        let subject = new Subject<number>();
        this.http
            .post(environment.localApi + 'ServiceUser/createServiceUser', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<number>) => {
                    subject.next(res.returnItem);
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage(this.translationService.translate('info_service_user_registered'));
                    this.alertsService.changeAlertSuccessShow(true);
                },
                (error) => {
                    this.alertsService.changealertHeader(this.translationService.translate('error_service_user_not_registered'));
                    this.alertsService.changeAlertErrorMessage(error.error.errorItem.message);
                    this.alertsService.changeAlertErrorShow(true);
                    subject.next(null);
                    console.log(error);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public updateServiceUser(req: ExposedUpdateServiceUsersReq): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(this.translationService.translate('info_save_service_user_data'));

        let subject = new Subject<number>();
        this.http
            .post(environment.localApi + 'ServiceUser/updateServiceUser', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<number>) => {
                    subject.next(res.returnItem);
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage(this.translationService.translate('info_service_user_updated'));
                    this.alertsService.changeAlertSuccessShow(true);
                },
                (error) => {
                    this.alertsService.changealertHeader(this.translationService.translate('error_service_user_not_updated'));
                    this.alertsService.changeAlertErrorMessage(error.error.errorItem.message);
                    this.alertsService.changeAlertErrorShow(true);
                    subject.next(null);
                    console.log(error);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public updateServiceUserRoles(req: ExposedUpdateServiceUserRolesReq): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(this.translationService.translate('info_save_service_user_data'));

        let subject = new Subject<number>();
        this.http
            .post(environment.localApi + 'ServiceUser/updateServiceUserRoles', req, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<number>) => {
                    subject.next(res.returnItem);
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage(this.translationService.translate('info_service_user_updated'));
                    this.alertsService.changeAlertSuccessShow(true);
                },
                (error) => {
                    this.alertsService.changealertHeader(this.translationService.translate('error_service_user_not_updated'));
                    this.alertsService.changeAlertErrorMessage(error.error.errorItem.message);
                    this.alertsService.changeAlertErrorShow(true);
                    subject.next(null);
                    console.log(error);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public deleteServiceUser(req: ExposedDeleteServiceUserReq): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage(this.translationService.translate('info_save_service_user_data'));

        let subject = new Subject<number>();
        this.http
            .delete(environment.localApi + `ServiceUser/DeleteServiceUser/${req.userId}`, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<null>) => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage(this.translationService.translate('info_service_user_deleted'));
                    this.alertsService.changeAlertSuccessShow(true);
                    subject.next(null);
                },
                (error) => {
                    this.alertsService.changealertHeader(this.translationService.translate('error_service_user_not_deleted'));
                    this.alertsService.changeAlertErrorMessage(error.error.errorItem.message);
                    this.alertsService.changeAlertErrorShow(true);
                    subject.next(null);
                    console.log(error);
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listServiceUserDomains(showLoader = true): Observable<Array<ExposedListServiceUserDomainsRes>> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage(this.translationService.translate('info_fetching_information'));
        }

        let subject = new Subject<Array<ExposedListServiceUserDomainsRes>>();
        this.http
            .get(environment.localApi + 'ServiceUser/listServiceUserDomains', this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe(
                (res: HttpStatus<Array<ExposedListServiceUserDomainsRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    subject.next(null);
                    console.log(error);
                }
            )
            .add(() => {
                if (showLoader) {
                    this.loaderService.changeActiveLoaders(-1);
                }
            });
        return subject.asObservable();
    }
}
